/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import ReporterPresenter from "./ReporterPresenter";
import DTOReporter from "./DTOReporter";
import ReporterType from "../../../../infra/aggregates/reportsToInterface";
import { useAppSelector } from "../../../../infra/hooks";
import { useTranslation } from "react-i18next";

function ReporterController() {
  const { t, i18n } = useTranslation();

  const [reportsTo, setReportsTo] = useState<ReporterType>({
    emp_pic: "",
    emp_name: "",
    emp_designation: "",
    manager_award: "",
  });

  const [teamMembers, setTeamMembers] = useState({});
  const isLoading = useAppSelector(
    (state) => state.reportsToSlice.reporterRefresh
  );

  function callBackReporterData(data: ReporterType) {
    setReportsTo({
      emp_pic: data.emp_pic,
      emp_name: data.emp_name,
      emp_designation: data.emp_designation,
      manager_award: data.manager_award,
    });
  }

  function getTeamMembers(data: any) {
    setTeamMembers(data);
  }
  
  return (
    <>
      <DTOReporter
        setReporterData={callBackReporterData}
        setTeamMembers={getTeamMembers}
      />
      <ReporterPresenter
        reporter={reportsTo}
        isLoading={isLoading}
        teamMembers={teamMembers}
        i18n={i18n}
        trans={t}
      />
    </>
  );
}

export default ReporterController;
